import { EnvironmentConfig, getFlag } from '../../utils/environmentUtils';
import { Preferences } from '@capacitor/preferences';
import { SETTINGS_STORAGE_KEY, Settings } from '../../features/settings/settingsState';
import {
  isPermittedNetworkConnected as isPermittedNetworkConnectedBase,
  makeIsPermittedNetworkConnectedRecoilState,
} from '@otuvy/ionic-react-common';

/**
 * Only exported for the debug page, otherwise we would keep this private
 */
export async function wifiOnlySetting(): Promise<boolean> {
  const { value } = await Preferences.get({ key: SETTINGS_STORAGE_KEY });

  if (!value) {
    return false;
  }
  const parsedSettings: Settings = JSON.parse(value);

  return parsedSettings.wifiOnly ?? false;
}

/**
 * WARNING: This only works properly on mobile. On web, it will always show as connected through wifi.
 */
export default async function isPermittedNetworkConnected(): Promise<boolean> {
  return isPermittedNetworkConnectedBase({
    serverSyncEnabled: getFlag(EnvironmentConfig.SERVER_SYNC),
    wifiOnlySetting,
  });
}

/**
 * WARNING: This only works properly on mobile. On web, it will always show as connected.
 */
export const isPermittedNetworkConnectedState = makeIsPermittedNetworkConnectedRecoilState({
  serverSyncEnabled: getFlag(EnvironmentConfig.SERVER_SYNC),
  wifiOnlySetting,
});
